import PropTypes from 'prop-types';
import { Box, Card, CardContent, Grid, Typography } from '@mui/material';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import TrendingDownIcon from '@mui/icons-material/TrendingDown';
import { formatKpiValue, KPI_ACCENT, pickLayout, rowValue } from '../kpiUtils';

const KpiMetricCard = ({ item }) => {
    const layout = pickLayout(item.layout, { md: 3, sm: 6, height: 148 });
    const config = item.config || {};
    const row = (item.rows && item.rows[0]) || {};
    const value = rowValue(row, config.valueKey, ['valor', 'value', 'total', 'qtd']);
    const subtitle = rowValue(row, config.subtitleKey, ['subtitulo', 'label', 'descricao']);
    const trend = rowValue(row, config.trendKey, ['variacao', 'trend']);
    const color = config.color || KPI_ACCENT;
    const format = config.format || 'number';
    const prefix = config.prefix || '';
    const suffix = config.suffix || '';

    return (
        <Grid item xs={layout.xs} sm={layout.sm} md={layout.md} lg={layout.lg}>
            <Card
                elevation={0}
                sx={{
                    height: layout.height,
                    borderRadius: 3,
                    border: '1px solid #EDE4F5',
                    background: `linear-gradient(180deg, #ffffff 0%, #fbf7ff 100%)`,
                    overflow: 'hidden',
                    position: 'relative'
                }}
            >
                <Box sx={{ position: 'absolute', top: 0, left: 0, right: 0, height: 4, bgcolor: color }} />
                <CardContent sx={{ height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                    <Typography variant="subtitle2" sx={{ color: '#6B5A78', fontWeight: 600, letterSpacing: 0.3 }}>
                        {item.titulo}
                    </Typography>
                    <Typography variant="h3" sx={{ fontWeight: 800, color: '#2A1638', lineHeight: 1.1 }}>
                        {prefix}
                        {formatKpiValue(value, format, config)}
                        {suffix}
                    </Typography>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, minHeight: 24 }}>
                        {trend !== null && trend !== undefined && trend !== '' && (
                            <Box sx={{ display: 'flex', alignItems: 'center', color: Number(trend) >= 0 ? '#2E7D32' : '#C62828' }}>
                                {Number(trend) >= 0 ? <TrendingUpIcon fontSize="small" /> : <TrendingDownIcon fontSize="small" />}
                                <Typography variant="caption" sx={{ fontWeight: 700 }}>
                                    {formatKpiValue(trend, Number(trend) > -1 && Number(trend) < 1 ? 'percent' : 'number')}
                                </Typography>
                            </Box>
                        )}
                        {subtitle && (
                            <Typography variant="caption" sx={{ color: '#8A7A98' }}>
                                {subtitle}
                            </Typography>
                        )}
                    </Box>
                </CardContent>
            </Card>
        </Grid>
    );
};

KpiMetricCard.propTypes = {
    item: PropTypes.object
};

export default KpiMetricCard;
